import {
  addDirectDebitToPrn,
  deactivateDirectDebitPaymentMethod,
  getSelfServiceRSAManagePaymentPageUrl,
  setDirectDebitAssetLineItemStatuses,
  updateDirectDebitPaymentMethod,
} from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import {
  IApttusDirectDebitRequest,
  IAssetLineItemDirectDebitStatusesRequest,
  ISuccessResponse,
} from '@/interfaces/make-a-payment/make-a-payment.interface';

export const ManageDirectDebitService = {
  /**
   * Add Direct Debit to PRN
   *
   * @param request
   */
  /**
   * add direct debit to apttus asset
   * @param apttusId apttus asset line item id
   * @param directDebitRequest direct debit request
   * @returns
   */
  addDirectDebitToPrn(apttusId: string, directDebitRequest: IApttusDirectDebitRequest): Promise<ISuccessResponse> {
    return _http.HttpPost(addDirectDebitToPrn.replace('{0}', apttusId), directDebitRequest);
  },
  /**
   * Set Asset Line Item Status
   *
   * @param request
   */
  /**
   * add direct debit to apttus asset
   * @param apttusId apttus asset line item id
   * @param items asset items
   * @returns
   */
  setDirectDebitAssetLineItemStatuses(
    apttusId: string,
    request: IAssetLineItemDirectDebitStatusesRequest
  ): Promise<ISuccessResponse> {
    return _http.HttpPut(setDirectDebitAssetLineItemStatuses.replace('{0}', apttusId), request);
  },
  /**
   * Get Self service RSA Direct Debit Page
   *
   * @param request
   */
  /**
   * get rsa direct debit page url
   * @returns url
   */
  getSelfServiceRSAManagePaymentMethodPage(): Promise<string> {
    return _http.HttpGet(`${getSelfServiceRSAManagePaymentPageUrl}`);
  },
  /**
   * Update Direct debit payment
   *
   * @param request
   */
  /**
   * update direct debit to apttus
   * @param apttusId apttus asset line item id
   * @param paymentMethodId payment method Id
   * @param request apttus direct debit request
   * @returns
   */
  updateDirectDebitPayment(
    apttusId: string,
    paymentMethodId: string,
    request: IApttusDirectDebitRequest
  ): Promise<ISuccessResponse> {
    return _http.HttpPut(
      updateDirectDebitPaymentMethod.replace('{0}', apttusId).replace('{1}', paymentMethodId),
      request
    );
  },
  /**
   * Deactivate Direct Debit
   *
   * @param request
   */
  /**
   * add direct debit to apttus asset
   * @param apttusId apttus asset line item id
   * @param directDebitRequest direct debit request
   * @returns
   */
  deactivateDirectDebitPaymentMethod(apttusId: string, paymentMethodId: string): Promise<ISuccessResponse> {
    return _http.HttpDelete(
      deactivateDirectDebitPaymentMethod.replace('{0}', apttusId).replace('{1}', paymentMethodId)
    );
  },
};
